import { FileFilters } from '../components/Dashboard/types/dashboard.types';

const DRONE_SELECTION_KEY = 'dashboard_selected_drone';
const FILE_FILTERS_KEY = 'dashboard_file_filters';

export const getInitialSelectedSerial = (): string => {
  try {
    return localStorage.getItem(DRONE_SELECTION_KEY) || '';
  } catch {
    return '';
  }
};

export const persistSelectedSerial = (serial: string): void => {
  try {
    if (serial) {
      localStorage.setItem(DRONE_SELECTION_KEY, serial);
    } else {
      localStorage.removeItem(DRONE_SELECTION_KEY);
    }
  } catch {
    // Silently fail if localStorage is not available
  }
};

export const getInitialFileFilters = (): FileFilters => {
  try {
    const stored = localStorage.getItem(FILE_FILTERS_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Ensure new fields have defaults for backwards compatibility
      return {
        selectedSerial: parsed.selectedSerial || 'All',
        startDate: parsed.startDate || null,
        endDate: parsed.endDate || null,
        sortBy: parsed.sortBy || 'name',
        sortOrder: parsed.sortOrder || 'asc',
        includeUntagged: parsed.includeUntagged ?? false,
      };
    }
  } catch {
    // Silently fail if localStorage is not available or JSON parse fails
  }
  return {
    selectedSerial: 'All',
    startDate: null,
    endDate: null,
    sortBy: 'name',
    sortOrder: 'asc',
    includeUntagged: false,
  };
};

export const persistFileFilters = (fileFilters: FileFilters): void => {
  try {
    localStorage.setItem(FILE_FILTERS_KEY, JSON.stringify(fileFilters));
  } catch {
    // Silently fail if localStorage is not available
  }
};
